import { useEffect, useRef, useState } from "react";

let apiPromise = null;
const loadYT = () => {
  if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
  if (!apiPromise) {
    apiPromise = new Promise((resolve) => {
      const prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => { prev?.(); resolve(window.YT); };
      const s = document.createElement("script");
      s.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(s);
    });
  }
  return apiPromise;
};

// Muted, controls-free loop of `seconds` from `start`, used as a living background. Calls onReady once playing.
export const AmbientVideo = ({ videoId, start = 5, seconds = 5, onPlaying, className = "" }) => {
  const hostRef = useRef(null);
  const playerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!videoId || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    let cancelled = false;
    let timer;
    loadYT().then((YT) => {
      if (cancelled || !hostRef.current) return;
      playerRef.current = new YT.Player(hostRef.current, {
        videoId,
        width: "100%",
        height: "100%",
        playerVars: { autoplay: 1, mute: 1, controls: 0, disablekb: 1, fs: 0, rel: 0, playsinline: 1, iv_load_policy: 3, start, modestbranding: 1 },
        events: {
          onReady: (e) => { e.target.mute(); e.target.playVideo(); },
          onStateChange: (e) => {
            if (e.data === YT.PlayerState.PLAYING) {
              setVisible(true);
              onPlaying?.();
              clearInterval(timer);
              timer = setInterval(() => {
                const p = playerRef.current;
                if (p && p.getCurrentTime && p.getCurrentTime() >= start + seconds) p.seekTo(start, true);
              }, 250);
            }
            if (e.data === YT.PlayerState.ENDED) e.target.seekTo(start, true);
          },
        },
      });
    });
    return () => {
      cancelled = true;
      clearInterval(timer);
      try { playerRef.current?.destroy(); } catch { /* noop */ }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoId]);

  if (!videoId) return null;
  return (
    <div data-testid="ambient-video" className={`absolute inset-0 overflow-hidden pointer-events-none transition-opacity duration-1000 ${visible ? "opacity-100" : "opacity-0"} ${className}`} aria-hidden>
      <div className="absolute inset-y-0 -inset-x-[8%] [&>iframe]:w-full [&>iframe]:h-full">
        <div ref={hostRef} className="w-full h-full" />
      </div>
    </div>
  );
};
